export type Props = {
  img?: string;
  title: string;
  description: string;
  price?: number;
  author: string | string[];
  contact: string;
  route: string;
}

export const Items: Props[] = [
  {
    img: '/assets/images/shop/ar-pack.jpg',
    title: "Автоматические винтовки LAPD",
    description: "",
    price: 8450,
    author: "raynott",
    contact: "https://discordapp.com/users/440193115631124500",
    route: "/shop/ar-pack",
  },
  {
    img: '/assets/images/shop/smg-pack.jpg',
    title: "Пистолеты-пулемёты LAPD",
    description: "",
    price: 8450,
    author: "raynott",
    contact: "https://discordapp.com/users/440193115631124500",
    route: "/shop/smg-pack",
  },
]